import { toast } from "react-toastify";
import { axios } from "../../../../../utils/axios";
import { toastOptions } from "../../../../../config/toast";
import { useGeneralAppStore } from "../../../../../store/generalAppStore";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

export const getDatosTitularPatente = async (submittedData, setDatosTitular, setError) => {
  try {
    handlerLoading({ loading: true, loadName: "datos_patente" });
    const result = await axios().get(`obtener_datos_titular/${submittedData.patente}`);
    const { status } = result;
    const { data, error } = result.data;

    if (data) {
      setDatosTitular(data);
      handlerModal({ modal: true, modalName: "datos_mcd" });
    }

    if (error) {
      if (status !== 422) {
        toast.error(error, toastOptions);
      } else {
        Object.entries(error).forEach((err, i) => {
          setError(err[0], { type: err[0], message: err[1][0] }, { shouldFocus: false });
        });
      }
    }
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "datos_patente" });
  }
};

export const aprobarDenuncia = async (submittedData, setInfraccionesNuevas, setError) => {
  try {
    handlerLoading({ loading: true, loadName: "aprobar_acta" });
    const result = await axios().post("aprobar_denuncia", submittedData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const { status } = result;
    const { data, error } = result.data;

    if (data) {
      toast.success(
        `Denuncia aprobada correctamente. Número de acta: ${data.acta?.dependencia}-${data.acta?.numero_acta}`,
        toastOptions
      );
      setInfraccionesNuevas((prevState) => {
        const dataActualizada = prevState.data.filter(
          (denuncia) => denuncia.id !== submittedData.id
        );
        return {
          ...prevState,
          data: dataActualizada,
          infraccion_seleccionada: null,
        };
      });
    }

    if (error) {
      if (status !== 422) {
        toast.error(error, toastOptions);
      } else {
        Object.entries(error).forEach((err, i) => {
          setError(err[0], { type: err[0], message: err[1][0] }, { shouldFocus: false });
        });
      }
    }
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "aprobar_acta" });
  }
};
export const anularDenuncia = async (payload, setInfraccionesNuevas) => {
  try {
    handlerLoading({ loading: true, loadName: "anular_denuncia" });
    const result = await axios().post("anular_denuncia", payload);
    const { status } = result;
    const { data, error } = result.data;

    if (data) {
      toast.success(`Denuncia anulada correctamente.`, toastOptions);
      setInfraccionesNuevas((prevState) => {
        const dataActualizada = prevState.data.filter((denuncia) => denuncia.id !== payload.id);
        return {
          ...prevState,
          data: dataActualizada,
          infraccion_seleccionada: null,
        };
      });
    }

    if (error) {
      toast.error(error, toastOptions);
    }
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "anular_denuncia" });
  }
};
